/**
 * @generated SignedSource<<13f07ce55b8275de0f9b303c7e939c11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfirmRemoveFromProgramDialog_enrollment$data = {
  readonly client: {
    readonly displayName: string | null | undefined;
  };
  readonly id: string;
  readonly program: {
    readonly name: string;
  };
  readonly " $fragmentType": "ConfirmRemoveFromProgramDialog_enrollment";
};
export type ConfirmRemoveFromProgramDialog_enrollment$key = {
  readonly " $data"?: ConfirmRemoveFromProgramDialog_enrollment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfirmRemoveFromProgramDialog_enrollment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfirmRemoveFromProgramDialog_enrollment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Program",
      "kind": "LinkedField",
      "name": "program",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Enrollment",
  "abstractKey": null
};

(node as any).hash = "76862ec542b8b571f53f9d09d5575844";

export default node;
